import React, { useCallback, useState,useRef, useEffect } from 'react';
import SettingPrompt from '../../../../components/SettingPrompt';
import { Box, Layout, Page, PageActions, Toast,Text, BlockStack,Card ,SkeletonBodyText} from '@shopify/polaris';
import intl from '../../../../i18n/intl';
import './index.css';
import NavTabs from '../components/NavTabs';
import AccountInfoBox from './component/AccountInfoBox';
import StoreInfoBox from './component/StoreInfoBox';
import ListProductBox from './component/ListProductBox';
import AddressEditBox from './component/AddressEditBox';
import LogoEditBox from './component/LogoEditBox';
import ResouceBox from './component/ResouceBox';
import _ from 'lodash'; // 使用 lodash 的深比较函数
import { reqGetInfoSetting, reqPutSettingSave } from '../../../../api';
import { store } from '../../../../store';
import { changeBannerData } from '../../../../slice';
const GeneralClass = ({changeSettingBtnState})=> {
  const shopify = window.shopify;
  
  // 配置保存按钮
  const [btnSaveState, setBtnSaveState] = useState({
    saveDataLoading: false,
    disabledSaveData: true
  });

  const [initPage,setInitPage] = useState(true);
  
  // 数据内容
  const [pageData, setPageData] = useState({});
  // 地址数据内容 做自维护,不进行更新状态
  const [addressList, setAddressList] = useState({});
  // 使用 useRef 保存初始数据和初始化状态
  const initialPageData = useRef(null);
  const isInitialized = useRef(false);
  // 使用 ref 保存函数引用（避免重复绑定到 window）
  const saveDataRef = useRef();
  const cancelDataRef = useRef();
// 优化后的差异检测函数
  const getObjectChanges = (initial, current) => {
  const changes = {};

  // 主比较逻辑
  const compare = (obj1, obj2, basePath = '') => {
    // 处理基本类型
    if (typeof obj2 !== 'object' || obj2 === null) {
      if (!_.isEqual(obj1, obj2)) {
        setDeepValue(changes, basePath, obj2);
      }
      return;
    }

    // 处理数组
    if (Array.isArray(obj2)) {
      if (!_.isEqual(obj1, obj2)) {
        setDeepValue(changes, basePath, obj2);
      }
      return;
    }

    // 递归处理对象
    Object.keys(obj2).forEach(key => {
      const newPath = basePath ? `${basePath}.${key}` : key;
      if (!(key in obj1)) {
        setDeepValue(changes, newPath, obj2[key]);
      } else {
        compare(obj1[key], obj2[key], newPath);
      }
    });

    // 检测删除的字段
    Object.keys(obj1).forEach(key => {
      const newPath = basePath ? `${basePath}.${key}` : key;
      if (!(key in obj2)) {
        setDeepValue(changes, newPath, undefined);
      }
    });
  };

  compare(initial, current);
  return changes;
};

// 辅助函数：安全设置嵌套值
const setDeepValue = (obj, path, value) => {
  const keys = path.split('.');
  let current = obj;
  
  keys.slice(0, -1).forEach(key => {
    if (!current[key]) current[key] = {};
    current = current[key];
  });
  
  const lastKey = keys[keys.length - 1];
  if (value === undefined) {
    delete current[lastKey];
  } else {
    current[lastKey] = value;
  }
};

  //  获取数据
  const getPageData = async () => {
    try {
      let res = await reqGetInfoSetting({type:'general'})
      if (res.code === '200') {
        setPageData(res.data);
        setAddressList(res.data.address_management);
        initialPageData.current = _.cloneDeep(res.data);
      }else {}
      setInitPage(false)
    } catch (error) {
    }
  };
  const cancelData = () => {
      setPageData((prev)=>({
        ...prev,
        ...initialPageData.current,
      }))
      changeSettingBtnState(false)
      setBtnSaveState(prev => ({
        ...prev,
        disabledSaveData: true
      }));
    }
  // 保存数据
  const saveData = async () => {
      try {
        setBtnSaveState(prev => ({
          ...prev,
          saveDataLoading: true
        }));
      let params = {
      type:'general',
      }
      const changes = getObjectChanges(initialPageData.current,pageData);// 仅上传变动值
      if (!_.isEmpty(changes)) {
        if (changes?.account_info) {
        params = {
          ...params,
          ...changes?.account_info
        }
        }
        if (changes?.list_product_setting) {
        params = {
          ...params,
          ...changes?.list_product_setting
        }
        }
        if (changes?.logo_url === '' || changes?.logo_url !== '') {
        params.logo_url = changes?.logo_url
        }
      }
      const res = await reqPutSettingSave(params)
      if (res.code === '200') {
        // success
        setBtnSaveState(prev => ({
          ...prev,
          disabledSaveData: true,
          saveDataLoading: false
        }));
        initialPageData.current = _.cloneDeep(pageData);
        setTimeout(() => {
          changeSettingBtnState(false)
        }, 1000);
        toastFun('Saved successfully')
      }else{
         changeSettingBtnState(false)
        store.dispatch(changeBannerData({bannerData:{
          show:true,
          desc:res.msg
        }}));
      }
      } catch (error) {
      }
  }
  // 更新 ref 的当前值（每次函数更新时同步）
  useEffect(() => {
    saveDataRef.current = saveData;
    cancelDataRef.current = cancelData;
  });
useEffect(() => {
  if (!isInitialized.current) {
    // 组件首次加载时，记录初始数据并标记初始化完成
    getPageData()
    isInitialized.current = true;
  } else {
    // 后续数据变动时，比较当前数据与初始数据
    const isDataChanged = !_.isEqual(pageData, initialPageData.current);
    setBtnSaveState(prev => ({
      ...prev,
      disabledSaveData: !isDataChanged
    }));
    if (isDataChanged) {
      window.saveSettings = { saveData: saveDataRef.current };
      window.cancelSetting = { cancelData: cancelDataRef.current };
    }
  }
}, [pageData]); // 监听 pageData 的变化

  useEffect(() => { 
    changeSettingBtnState(!btnSaveState.disabledSaveData)
  }, [btnSaveState,changeSettingBtnState]);
// 组件卸载时清理
useEffect(() => {
  return () => {
    window.saveSettings = null;
    window.cancelSetting = null;
  };
}, []);
  const [toast, setToast] = useState(false); // 提示
  const [toastError, setToastError] = useState(false);
  const [toastMsg, setToastMsg] = useState("");

  const toggleToast = useCallback(() => setToast((toast) => !toast), []);

  const toastMarkup = toast ? (
    <Toast content={toastMsg} onDismiss={toggleToast} error={toastError} />
  ) : null;

  const toastFun = (msg, error) => {
    setToastError(error);
    setToastMsg(msg);
    setToast(false);
    toggleToast();
  };
  
  const pageContent = (
    <Box>
      <BlockStack gap={500}>
        <Box className='h1_m'>
      <Text variant="headingLg" as="h5">
        General
      </Text>
      </Box>
      {/* 名字、邮箱、密码修改 */}
      <AccountInfoBox pageData={pageData} setPageData={setPageData} />
      {/* 店铺信息 */}
      <StoreInfoBox pageData={pageData}/>
      {/* 产品导入设置 */}
      <ListProductBox pageData={pageData} setPageData={setPageData}/>
      {/* 地址信息 */}
      <AddressEditBox addressList={addressList} setAddressList={setAddressList} toastFun={toastFun}/>
      {/* logo信息 */}
      <LogoEditBox pageData={pageData} setPageData={setPageData}/>
      {/* 跳转信息 */}
      <ResouceBox />
      </BlockStack>

    </Box>
  )
  const initSkeletonPage = (
    <Box className="skeleton_page">
      <Box className="skeleton_page_children">
        <Card>
        <BlockStack gap={400}>
        <SkeletonBodyText lines={3}/>
        <SkeletonBodyText lines={3}/>
        <SkeletonBodyText lines={3}/>
        <SkeletonBodyText lines={3}/>
        <SkeletonBodyText lines={3}/>
        <SkeletonBodyText lines={3}/>
        <SkeletonBodyText lines={3}/>
        <SkeletonBodyText lines={3}/>
        <SkeletonBodyText lines={3}/>
        <SkeletonBodyText lines={3}/>
        <SkeletonBodyText lines={3}/>
        </BlockStack>
        </Card>
        </Box>
        </Box>
    )
  return (
    <div className={shopify ? 'setting_page_shopify' : 'setting_page'}>
      {!shopify && <SettingPrompt disabledSaveData={btnSaveState.disabledSaveData} url='/admin/settings/general' saveData={saveData} />}
        <Page
          title={shopify ? '' : intl.get("Settings")}
          separator
        >
        <Layout>
        <Layout.Section variant="oneThird">
            <NavTabs selected="General" saveData={saveData} loading={btnSaveState.saveDataLoading} disabled={btnSaveState.disabledSaveData}/>
        </Layout.Section>
        <Layout.Section>
        {initPage && initSkeletonPage }
        <Box style={{opacity: initPage ? 0 : 1}}>
        {pageContent}
        </Box>
        </Layout.Section>
        </Layout>
          {toastMarkup}
          <PageActions 
          primaryAction={
            {
              content: intl.get("Save"),
              onAction: saveData,
              loading: btnSaveState.saveDataLoading,
              disabled: btnSaveState.disabledSaveData
            }
          }
          >
            </PageActions>
        </Page>
    </div>
  );
}

export default GeneralClass;
